<template>
  <div>
    <vs-card>
      <vs-input
        class="w-full"
        name="email"
        :label="$t('labels.model')"
        v-model="model"
        icon-no-border
      />
      <vs-input class="w-full" name="email" :label="$t('labels.id')" v-model="id" />
      <vs-button class="mt-4 w-full" type="filled" @click.prevent="letsGo">{{ $t('labels.go') }}</vs-button>
    </vs-card>
    <list v-if="flag" :model="input.model" :id="input.id"></list>
  </div>
</template>

<script>
import list from "@/layouts/components/activities/list.vue";
export default {
  components: {
    list
  },
  data() {
    return {
      model: "user",
      id: "1",
      input: {},
      flag: false
    };
  },
  methods: {
    letsGo() {
      this.flag = false;
      setTimeout(() => {
        this.input = {
          model: this.model,
          id: this.id
        };
        this.flag = true;
      }, 100);
    }
  }
};
</script>